import { render } from "./btn.vue?vue&type=template&id=e86b64b6"
import script from "./btn.vue?vue&type=script&lang=js"
export * from "./btn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewamistad/Sites/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__